import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const USER_FILTER_OPTIONS = ['전체', '기존 사용자', '신규 사용자'] as const;
export type UserFilterValue = (typeof USER_FILTER_OPTIONS)[number];

type Props = {
  value: UserFilterValue;
  onChange: (value: UserFilterValue) => void;
};

const selectSx = {
  bgcolor: '#f8fafc',
  borderRadius: 2.5,
  overflow: 'hidden' as const,
  '& fieldset': {
    borderColor: '#e2e8f0',
    borderRadius: 2.5,
  },
  '&:hover fieldset': {
    borderColor: '#cbd5e1',
  },
  '&.Mui-focused fieldset': {
    borderColor: '#0044D2',
  },
  '& .MuiSelect-select': {
    py: 1.2,
    px: 1.75,
    fontWeight: 500,
    color: '#475569',
  },
  '& svg': { color: '#64748b' },
};

export default function FilterSelectorUser({ value, onChange }: Props) {
  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: '#ffffff',
        maxWidth: 640,
        width: '100%',
        height: { xs: 'auto', md: 125 },
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
        border: '1px solid #f1f5f9',
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={2}
        color="#475569"
        sx={{ fontSize: '0.95rem' }}
      >
        사용자 필터
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
        }}
      >
        <FormControl size="small" sx={{ minWidth: 160, width: { xs: '100%', md: 320 } }}>
          <Select
            value={value}
            onChange={(e) => onChange(e.target.value as UserFilterValue)}
            IconComponent={KeyboardArrowDownIcon}
            sx={selectSx}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                  borderRadius: 2.5,
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.10)',
                  '& .MuiMenuItem-root': {
                    fontWeight: 500,
                    py: 1.25,
                  },
                },
              },
            }}
          >
            {USER_FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}
